/** @module components/signup-overlay */
import baustein from "baustein";
import analytics from "web/script/analytics/analytics";
import environment from "web/script/modules/environment";
import history from "web/script/utils/history";
import overlayMixin from "web/script/components/mixins/overlay-mixin";
import requester from "web/script/modules/requester";
import globals from "web/script/modules/globals";

import SignupOverlay from "web/script/components/overlays/signup-overlay";

/**
 * Handles functionality of the sign up overlay
 *
 * @constructor
 * @alias module:components/signup-overlay
 * @extends module:baustein
 */
export default baustein.register(
    "login-overlay",
    /** @lends module:components/signup-overlay.prototype */
    {
        mixins: [overlayMixin],

        defaultOptions: {
            overlaySize: "width-750",
            noContentPadding: true,
            queryParams: {},
            path: "/account/login/",
            formType: "unknown",
            loginSuccessRedirectUrl:
                window && window.location && window.location.pathname + window.location.search,
        },

        setupEvents: function(add) {
            add("form-submit-success", "ajax-form", this.onSubmitSuccess);
            add("click", ".registration-link", this.switchToSignup);
        },

        onOverlayCloseIntent() {
            const eventCategory = this._getEventCategory();
            analytics.event(eventCategory, "close_signin_form", "exit_signin");
            history.back();
            this.close();
        },

        onOverlayOpen() {
            this.trackPageView();
        },

        trackPageView() {
            analytics.pageView();
        },

        switchToSignup(event) {
            if (event) {
                event.preventDefault();
            }
            this.close();
            const eventCategory = this._getEventCategory();
            analytics.event(eventCategory, "toggle", "sign_up");
            const pageType = "sigup_form";
            const pageSubType = eventCategory.replace("signin", "signup");
            environment.set({
                pageType,
                pageSubType,
            });
            const overlay = new SignupOverlay({
                isOverlay: true,
                queryParams: this.options.queryParams,
            });
            overlay.appendTo(document.body);
            overlay.open();
        },

        getOverlayContent() {
            const queryParams = this.options.queryParams;
            const redirectUrl = this.options.loginSuccessRedirectUrl;
            return requester(this.options.path, {
                headers: {
                    Accept: "text/html",
                },
                query: queryParams,
            }).then(function(resp) {
                // If we get back application/json then the user is
                // already logged in. Perhaps a further improvement -
                // we detect this when the save for later button is
                // clicked and redirect + save for later at the same
                // time
                if (
                    resp.status === 200 &&
                    resp.headers.get("content-type") === "application/json"
                ) {
                    globals.window.location = redirectUrl;
                    return;
                } else {
                    return requester.toText(resp);
                }
            });
        },

        _isSaveForLaterOverlay() {
            return this.options.formType.includes("save_for_later");
        },

        _getEventCategory() {
            const newSignupFormComponent = this.findComponent("signup-form");
            return newSignupFormComponent.options.eventCategory;
        },
    }
);
